 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"access-denied-access-denied-module":"access-denied-access-denied-module","default~ForgotPassword-forgotPassword-module~Modules-BasicData-AcademicDegrees-academic-degrees-modu~d149fc01":"default~ForgotPassword-forgotPassword-module~Modules-BasicData-AcademicDegrees-academic-degrees-modu~d149fc01","default~ForgotPassword-forgotPassword-module~Modules-BasicData-AcademicDegrees-academic-degrees-modu~52fbe35e":"default~ForgotPassword-forgotPassword-module~Modules-BasicData-AcademicDegrees-academic-degrees-modu~52fbe35e","ForgotPassword-forgotPassword-module":"ForgotPassword-forgotPassword-module","default~Modules-BasicData-AcademicDegrees-academic-degrees-module~Modules-BasicData-Banks-banks-modu~ca7c2ee6":"default~Modules-BasicData-AcademicDegrees-academic-degrees-module~Modules-BasicData-Banks-banks-modu~ca7c2ee6","default~Modules-BasicData-AcademicDegrees-academic-degrees-module~Modules-BasicData-Banks-banks-modu~dd0fa540":"default~Modules-BasicData-AcademicDegrees-academic-degrees-module~Modules-BasicData-Banks-banks-modu~dd0fa540","default~Modules-BasicData-AcademicDegrees-academic-degrees-module~Modules-BasicData-Banks-banks-modu~fdfaff65":"default~Modules-BasicData-AcademicDegrees-academic-degrees-module~Modules-BasicData-Banks-banks-modu~fdfaff65","default~Modules-BasicData-AcademicDegrees-academic-degrees-module~Modules-BasicData-Banks-banks-modu~35429caa":"default~Modules-BasicData-AcademicDegrees-academic-degrees-module~Modules-BasicData-Banks-banks-modu~35429caa","default~VerifyServiceProvider-verify-service-provider-module~layout-layout-module":"default~VerifyServiceProvider-verify-service-provider-module~layout-layout-module","common":"common","VerifyServiceProvider-verify-service-provider-module":"VerifyServiceProvider-verify-service-provider-module","login-login-module":"login-login-module","resetpassword-resetpassword-module":"resetpassword-resetpassword-module","layout-layout-module":"layout-layout-module","not-found-not-found-module":"not-found-not-found-module","server-error-server-error-module":"server-error-server-error-module","blank-page-blank-page-module":"blank-page-blank-page-module","bs-component-bs-component-module":"bs-component-bs-component-module","bs-element-bs-element-module":"bs-element-bs-element-module","Modules-Membership-Role-role-module":"Modules-Membership-Role-role-module","Modules-BasicData-Countries-countries-module":"Modules-BasicData-Countries-countries-module","Modules-BasicData-Governorates-governorates-module":"Modules-BasicData-Governorates-governorates-module","Modules-BasicData-Languages-languages-module":"Modules-BasicData-Languages-languages-module","Modules-BasicData-Operations-operations-module":"Modules-BasicData-Operations-operations-module","Modules-BasicData-addons-addons-module":"Modules-BasicData-addons-addons-module","Modules-BasicData-anesthesia-types-anesthesia-types-module":"Modules-BasicData-anesthesia-types-anesthesia-types-module","Modules-BasicData-banks-data-banks-data-module":"Modules-BasicData-banks-data-banks-data-module","Modules-BasicData-complaint-types-complaint-types-module":"Modules-BasicData-complaint-types-complaint-types-module","Modules-BasicData-contact-us-contact-us-module":"Modules-BasicData-contact-us-contact-us-module","Modules-BasicData-insurance-companies-insurance-companies-module":"Modules-BasicData-insurance-companies-insurance-companies-module","Modules-BasicData-medical-tourism-medical-tourism-module":"Modules-BasicData-medical-tourism-medical-tourism-module","Modules-BasicData-room-types-room-types-module":"Modules-BasicData-room-types-room-types-module","Modules-CMS-ContactInfo-contact-info-module":"Modules-CMS-ContactInfo-contact-info-module","Modules-CMs-SocialMedia-social-media-module":"Modules-CMs-SocialMedia-social-media-module","Modules-Providers-CancelationPolicies-cancelation-policies-module":"Modules-Providers-CancelationPolicies-cancelation-policies-module","Modules-Providers-questions-questions-module":"Modules-Providers-questions-questions-module","Modules-SystemSettings-systemSettings-module":"Modules-SystemSettings-systemSettings-module","Modules-BasicData-AcademicDegrees-academic-degrees-module":"Modules-BasicData-AcademicDegrees-academic-degrees-module","Modules-BasicData-specialties-specialties-module":"Modules-BasicData-specialties-specialties-module","Modules-BasicData-sub-specialties-sub-specialties-module":"Modules-BasicData-sub-specialties-sub-specialties-module","Modules-Membership-Users-users-module":"Modules-Membership-Users-users-module","Modules-Providers-Offers-offers-module":"Modules-Providers-Offers-offers-module","Modules-Providers-ServiceProviderOffers-service-provider-offers-module":"Modules-Providers-ServiceProviderOffers-service-provider-offers-module","Modules-UserProfile-user-profile-module":"Modules-UserProfile-user-profile-module","default~Modules-BasicData-Banks-banks-module~Modules-Booking-booking-requests-operazi-admin-booking-~06569a72":"default~Modules-BasicData-Banks-banks-module~Modules-Booking-booking-requests-operazi-admin-booking-~06569a72","Modules-BasicData-Banks-banks-module":"Modules-BasicData-Banks-banks-module","Modules-CMS-our-service-cms-our-service-cms-module":"Modules-CMS-our-service-cms-our-service-cms-module","Modules-Providers-PackageRequests-package-requests-module":"Modules-Providers-PackageRequests-package-requests-module","Modules-Requests-ServiceProviderRequests-service-provider-requests-module":"Modules-Requests-ServiceProviderRequests-service-provider-requests-module","default~Modules-BasicData-cities-cities-module~Modules-Providers-ServiceProviders-service-providers-~3dd46a64":"default~Modules-BasicData-cities-cities-module~Modules-Providers-ServiceProviders-service-providers-~3dd46a64","Modules-Providers-ServiceProviders-service-providers-module":"Modules-Providers-ServiceProviders-service-providers-module","default~Modules-Booking-booking-requests-operazi-admin-booking-requests-operazi-admin-module~Modules~a4981da8":"default~Modules-Booking-booking-requests-operazi-admin-booking-requests-operazi-admin-module~Modules~a4981da8","Modules-medical-reports-medical-reports-module":"Modules-medical-reports-medical-reports-module","Modules-finances-admin-invoices-admin-invoices-module":"Modules-finances-admin-invoices-admin-invoices-module","Modules-finances-service-provider-invoices-service-provider-invoices-module":"Modules-finances-service-provider-invoices-service-provider-invoices-module","default~Modules-Booking-booking-requests-operazi-admin-booking-requests-operazi-admin-module~Modules~f41b4faf":"default~Modules-Booking-booking-requests-operazi-admin-booking-requests-operazi-admin-module~Modules~f41b4faf","Modules-Booking-booking-requests-operazi-admin-booking-requests-operazi-admin-module":"Modules-Booking-booking-requests-operazi-admin-booking-requests-operazi-admin-module","Modules-Providers-booking-requests-booking-requests-module":"Modules-Providers-booking-requests-booking-requests-module","default~Modules-Providers-Packages-packages-module~Modules-Providers-ServiceProviderPackageRequests-~bd2b46fa":"default~Modules-Providers-Packages-packages-module~Modules-Providers-ServiceProviderPackageRequests-~bd2b46fa","Modules-Providers-Packages-packages-module":"Modules-Providers-Packages-packages-module","Modules-Providers-ServiceProviderPackageRequests-service-provider-package-request-module":"Modules-Providers-ServiceProviderPackageRequests-service-provider-package-request-module","Modules-Providers-ServiceProviderPackages-service-provider-package-module":"Modules-Providers-ServiceProviderPackages-service-provider-package-module","Modules-BasicData-cities-cities-module":"Modules-BasicData-cities-cities-module","default~Modules-CMS-articles-articles-module~Modules-CMS-basic-cms-basic-cms-module~Modules-CMS-meta~2cb94264":"default~Modules-CMS-articles-articles-module~Modules-CMS-basic-cms-basic-cms-module~Modules-CMS-meta~2cb94264","Modules-CMS-basic-cms-basic-cms-module":"Modules-CMS-basic-cms-basic-cms-module","Modules-CMS-meta-tags-meta-tags-module":"Modules-CMS-meta-tags-meta-tags-module","Modules-CMS-articles-articles-module":"Modules-CMS-articles-articles-module","default~charts-charts-module~dashboard-dashboard-module":"default~charts-charts-module~dashboard-dashboard-module","dashboard-dashboard-module":"dashboard-dashboard-module","charts-charts-module":"charts-charts-module","form-form-module":"form-form-module","grid-grid-module":"grid-grid-module","tables-tables-module":"tables-tables-module"}[chunkId]||chunkId) + "-es5.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
